<template>
  <span>{{ moment(value) }}</span>
</template>
<script>
import moment from 'moment';
export default {
  props: ['value'],
  methods: {
    moment: function (date) {
        return moment.unix(date).format('DD-MM-YYYY');
    }
  },
}
</script>
